/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvYWRtaW4vbHNhLWFkbWluL3VzZXItbWFuYWdlbWVudC91c2VyLW1hbmFnbWVudC1tYWluL3VzZXItbWFuYWdtZW50LW1haW4uY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vYXBwL3NyYy9hcHAvY29tcG9uZW50cy9hZG1pbi9sc2EtYWRtaW4vdXNlci1tYW5hZ2VtZW50L3VzZXItbWFuYWdtZW50LW1haW4vdXNlci1tYW5hZ21lbnQtbWFpbi5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/admin/lsa-admin/user-management/user-managment-main/user-managment-main.component.scss.shim.ngstyle.ts